const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Бронзовые драконы хуже всех превращаются в гуманоидный облик. Они всегда всё украшают лишними волосами в самых неожиданных места. Я аплодирую их изобретательности, но в этом вопросе чем проще — тем лучше!`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
